import ErrorSafeguard from './ErrorSafeguard';

export default ErrorSafeguard;
